//jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   /*$( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });*/

//});
setTimeout(
  function(){
	$(document).ready(function(){
		setTimeout(
			function(){
				$(".aaa_form_class_8531").parent().attr("style","");
				$(".aaa_form_class_8531").addClass("t4s-row");
				$(".aaa_form_class_8531 .form-group").each(function(index, item){
					if(index != 17){
						$(this).wrapAll('<div class="t4s-col-sm-12 t4s-col-md-6 t4s-col-lg-6 t4s-col-item">');
					}else{
						$(this).wrapAll('<div class="t4s-col-sm-12 t4s-col-md-12 t4s-col-lg-12 t4s-col-item">');
					}
				});
			}
			, 3000
		);
	});
  },
  2000
);
